import React from 'react';

import { Button } from 'components/base/button';
import { Colors } from 'theme/colors';
import { FontSize } from 'theme/fonts';
import { Container } from 'theme/layout';
import { Regular } from 'theme/text';
import { AnimationListType } from 'theme';

const MOBILE_MARGIN = 30;
const DESKTOP_MARGIN = 40;

/**
 * Button used to initiate the next step in chat.
 *
 * @param props - Next button props.
 */
export function NextButton(props: Props) {
  const {
    onPress,
    disabled,
    loading,
    title,
    color: overrideColor,
    textColor: overrideTextColor,
    animationOverrides,
  } = props;
  const color = overrideColor ?? Colors.green;
  const textColor = overrideTextColor ?? Colors.white;
  const animation = (animationOverrides?.['greenPulse'] ?? 'greenPulse') as AnimationListType;

  return (
    <Container as="div" width={192} mx="auto" mt={[MOBILE_MARGIN, DESKTOP_MARGIN]}>
      <Button
        rounded
        accentColor={color}
        onPress={onPress}
        disabled={disabled}
        loading={loading}
        animation={animation}>
        <Regular fontSize={FontSize.H4} color={textColor}>
          {title || 'Next'}
        </Regular>
      </Button>
    </Container>
  );
}
/* Type definitions */
interface Props {
  /** When true, the continue button is disabled. */
  disabled?: boolean;
  /** Controls the button's loading state. */
  loading?: boolean;
  /** Emits an `onContinue` event when the continue button is pressed. */
  onPress(): void;
  title?: string;
  /** The color with which to override the button color */
  color?: string;
  /** The color with which to override the button text color */
  textColor?: string;
  /** A mapping of the name of the current animation to the name of the animation to replace it with */
  animationOverrides?: Record<string, string>;
}
